"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariants = getVariants;
const uom_1 = require("@genesys/uom");
function getVariants(geometry) {
    const variansIndices = geometry[0].reduce((a, _b, ix) => {
        var _a;
        if (((_a = geometry[1][ix]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === "id") {
            return a;
        }
        const allValuesAreTheSame = geometry
            .slice(3)
            .every(f => f[ix] === geometry[2][ix]);
        return allValuesAreTheSame ? a : a.concat(ix);
    }, []);
    const valueStr = (value, ix) => {
        const unitStr = geometry[0][ix];
        const header = geometry[1][ix];
        const unit = unitStringify(unitStr);
        return `${header}: ${value}` + (unit ? " " + unit : "");
    };
    const variants = geometry
        .slice(2)
        .map(g => variansIndices.map(ix => valueStr(g[ix], ix)));
    return variants;
}
function unitStringify(unit) {
    const trimmed = unit.substring(1, unit.length - 1);
    const maybeUnit = uom_1.Serialize.stringToUnit(trimmed);
    return maybeUnit ? uom_1.Format.getUnitFormat(maybeUnit, uom_1.UnitsFormat).label : "";
}
//# sourceMappingURL=variants.js.map